import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CourseGenerationRequest {
  id: string;
  source: string;
  prompt: string | null;
  contentId: string | null;
  courseId: string | null;
}

export function useCourseGenerationRequest(courseId: string | undefined) {
  return useQuery({
    queryKey: ["course-generation-request", courseId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("course_generation_requests")
        .select("id, source, prompt, content_id, course_id")
        .eq("course_id", courseId!)
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      if (!data) return null;
      return {
        id: data.id,
        source: data.source,
        prompt: data.prompt,
        contentId: data.content_id,
        courseId: data.course_id,
      } as CourseGenerationRequest;
    },
    enabled: !!courseId,
  });
}
